/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetExcelGenerationSettings = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The SheetExcelGenerationSettings model module.
   * @module model/SheetExcelGenerationSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetExcelGenerationSettings</code>.
   * @alias module:model/SheetExcelGenerationSettings
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>SheetExcelGenerationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetExcelGenerationSettings} obj Optional instance to populate.
   * @return {module:model/SheetExcelGenerationSettings} The populated <code>SheetExcelGenerationSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorGroupID')) {
        obj['IndicatorGroupID'] = ApiClient.convertToType(data['IndicatorGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomIndicatorIDs')) {
        obj['CustomIndicatorIDs'] = ApiClient.convertToType(data['CustomIndicatorIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('IndicatorDepthRuleID')) {
        obj['IndicatorDepthRuleID'] = ApiClient.convertToType(data['IndicatorDepthRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('ValueWriteRuleID')) {
        obj['ValueWriteRuleID'] = ApiClient.convertToType(data['ValueWriteRuleID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {Integer} IndicatorGroupID
   * @default 0
   */
  exports.prototype['IndicatorGroupID'] = 0;
  /**
   * @member {Array.<Integer>} CustomIndicatorIDs
   */
  exports.prototype['CustomIndicatorIDs'] = undefined;
  /**
   * @member {Integer} IndicatorDepthRuleID
   * @default 0
   */
  exports.prototype['IndicatorDepthRuleID'] = 0;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Integer} ValueWriteRuleID
   * @default 0
   */
  exports.prototype['ValueWriteRuleID'] = 0;



  return exports;
}));


